import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash.get';
import kindOf from 'kind-of';

import loadScript from 'lib/loadScript';
import { package as packagePropType } from 'lib/CustomPropTypes';
import { isLeadPackageAdjacent } from 'lib/packageHelper';

export default class Embed extends React.Component {
  static propTypes = {
    content: packagePropType.isRequired,
  };

  static contextTypes = {
    layoutIndex: PropTypes.number,
    leadPackageType: PropTypes.string,
  };

  componentDidMount() {
    let url = this.getUrl();

    if (url) {
      loadScript('https://nodeassets.nbcnews.com/cdnassets/pym/1.3.2/pym.min.js')
        .then(() => {
          if (window.pym) {
            // Strip query string params from url that might have been copied from development.
            url = url.replace(/&(childId|parentUrl)=[^&]+/g, '');
            // Pym adds iframe and establishes communication for controlling height.
            this.pymChild = new window.pym.Parent(this.id(), url);
          }
        });
    }
  }

  getUrl = () => get(this.props, 'content.metadata.url', false);

  id = () => {
    const { content: { id } = {} } = this.props;
    return `Embed-${id}`;
  };

  getToolkitClassesFromEmbedURL = (url) => {
    if (kindOf(url) !== 'string') {
      return '';
    }
    let ramenClasses;
    let styleClasses;
    if (url.includes('/ramen-classes_')) {
      const params = url.split('/');
      ramenClasses = params.filter((param) => param.includes('ramen-classes'));
      const [first = ''] = ramenClasses;
      [, styleClasses = ''] = first.split('_');
      if (styleClasses.includes('~')) {
        styleClasses = styleClasses.replace(/~/g, ' ');
      }
      return `${styleClasses} no-margin`;
    }
    return '';
  };

  render() {
    if (!this.getUrl()) {
      return null;
    }

    const { content: { id, packageIndex, metadata: { url } = {} } = {} } = this.props;
    const { layoutIndex, leadPackageType } = this.context;

    const toolKitClasses = this.getToolkitClassesFromEmbedURL(url);
    const shouldUseToolKitClasses = !!toolKitClasses;
    const leadPkgAdj = layoutIndex === 0
      && packageIndex === 1
      && isLeadPackageAdjacent(leadPackageType);

    return (
      <section
        className={classNames(
          'pkg relative',
          {
            'ph5 pt5 pa0-m': !shouldUseToolKitClasses,
            // Only add background-color and padding if a lead package is adjacent
            'bg-knockout-primary': leadPkgAdj,
            'ph6-m pt6-m': leadPkgAdj && !shouldUseToolKitClasses,
            [toolKitClasses]: shouldUseToolKitClasses,
          },
        )}
        data-packageid={id}
      >
        <div id={this.id()} />
      </section>
    );
  }
}
